export const generateShareLensURL = (lensID) => `https://www.snapchat.com/lens/${lensID}`;
